module.exports = __webpack_public_path__ + "static/img/service5.30bf9cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service5.jpg
// module id = 3OXB
// module chunks = 0